import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";
import { Modal } from "@grindex-components/Modal/modal.class";

const SELECTOR_MOBILE_THUMB = ".js-mobile-thumb";
const SELECTOR_DESKTOP_THUMB = ".js-desktop-thumb";
const SELECTOR_PLAY_ICONS = ".js-hero-play-icon";
const SELECTOR_INGRESS_ICON = ".js-ingrees-play-icon";
const SELECTOR_FLOATING_BUTTON = ".floating-button";
const SELECTOR_MODAL = "#xyl-modal-promotion";
const SELECTOR_MODAL_MARKETO_BUTTON = "#xyl-modal-promotion .mktoButton";
const SELECTOR_BOUNCE_IN_IMAGES = "[data-transition-bounceIn] img";
const SELECTOR_ANIMATION_ELEMENTS = ".js-animation-element";
const SELECTOR_IN_VIEW = ".in-view";

const SELECTOR_TRANSITION_FADEIN_SLOW = "[data-transition-fadeInSlow]";
const SELECTOR_TRANSITION_SCALEUP_FROM_60 = "[data-transition-scaleUpFrom60]";
const SELECTOR_TRANSITION_SCALEUP_FROM_60_PARENT = "[data-transition-scaleUpFrom60-parent] img";

const CLASS_BOUNCE_IN_TRANSITION = "transition--bounceIn";
const CLASS_TRANSITION = "transition";
const CLASS_NO_TRANSITION = "no-transition";
const CLASS_IN_VIEW = "in-view";

export default class SinglePagePromotionDom extends DomElementsBase {
	constructor($module) {
		const selectors = [
			SELECTOR_DESKTOP_THUMB,
			SELECTOR_INGRESS_ICON,
			SELECTOR_MOBILE_THUMB,
			SELECTOR_PLAY_ICONS,
			SELECTOR_FLOATING_BUTTON,
			SELECTOR_MODAL_MARKETO_BUTTON,
			SELECTOR_BOUNCE_IN_IMAGES,
			SELECTOR_ANIMATION_ELEMENTS,
			SELECTOR_IN_VIEW,
		];

		super($module, selectors);

		const modal = new Modal(document.querySelector(SELECTOR_MODAL));

		this.modal = modal;
	}

	getModal() {
		return this.modal;
	}

	getInViewElements() {
		return this.getElements(SELECTOR_IN_VIEW, true);
	}

	getAnimationElements() {
		return this.getElements(SELECTOR_ANIMATION_ELEMENTS);
	}

	getModalMarketoButton() {
		return this.getElement(SELECTOR_MODAL_MARKETO_BUTTON);
	}

	getMobileThumb() {
		return this.getElement(SELECTOR_MOBILE_THUMB);
	}

	getDesktopThumb() {
		return this.getElement(SELECTOR_DESKTOP_THUMB);
	}

	getPlayIcons() {
		return this.getElements(SELECTOR_PLAY_ICONS);
	}

	getIngreesIcon() {
		return this.getElement(SELECTOR_INGRESS_ICON);
	}

	getFloatingButton() {
		return this.getElement(SELECTOR_FLOATING_BUTTON);
	}

	getBounceInImages() {
		return this.getElements(SELECTOR_BOUNCE_IN_IMAGES);
	}

	activateBounceIn($element) {
		$element.classList.add(CLASS_TRANSITION, CLASS_BOUNCE_IN_TRANSITION);
	}

	getModalPrimaryColor() {
		return this.modal._$element.dataset.primaryColor;
	}

	getModalSecondaryColor() {
		return this.modal._$element.dataset.secondaryColor;
	}

	setModalMarketoButtonGradient(primaryColor, secondaryColor) {
		const style = `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`;

		this.getModalMarketoButton().style.background = style;
	}

	setAnimationInView($element) {
		$element.classList.add(CLASS_IN_VIEW);
	}

	setAnimationNotInView($element) {
		$element.classList.remove(CLASS_IN_VIEW);
	}

	hideBodyOverflow() {
		document.body.style.overflow = "hidden";
	}

	getExistingVideo(playerId, dataKey) {
		return document.querySelector(`#botr_${dataKey}_${playerId}_div`);
	}

	getElementToScroll(hash) {
		return document.querySelector(hash);
	}

	disableTransitions() {
		document.querySelectorAll(SELECTOR_TRANSITION_FADEIN_SLOW).forEach(($element) => {
			$element.classList.add(CLASS_NO_TRANSITION);
		});

		document.querySelectorAll(SELECTOR_TRANSITION_SCALEUP_FROM_60).forEach(($element) => {
			$element.classList.add(CLASS_NO_TRANSITION);
		});

		document.querySelectorAll(SELECTOR_TRANSITION_SCALEUP_FROM_60_PARENT).forEach(($img) => {
			$img.classList.add(CLASS_NO_TRANSITION);
		});
	}
}
